<template>
  <main-large-dialog
    v-bind="$props"
    :is-visible.sync="computedIsVisible"
    :title="$i18n.t(titlePath)"
    dialog-width="80%"
    min-body-height="400px"
    max-height="95vh"
    no-paddings-y
    no-paddings-x
    disagree-text="dialog.disagreeClose"
    agree-text="dialog.download"
    @agree="downloadChart"
  >
    <template #body>
      <v-col cols="12" class="px-15">
        <v-row no-gutters v-if="statistics">
          <template v-for="stat in statistics">
            <v-col cols="auto" :key="stat.name">
              <nmt-sidebar-profile-chart-dialog-chip v-bind="stat"></nmt-sidebar-profile-chart-dialog-chip>
            </v-col>
          </template>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <nmt-sidebar-profile-chart ref="chart" v-bind="$props" name="chartNmtDialog"></nmt-sidebar-profile-chart>
          </v-col>
        </v-row>
      </v-col>
    </template>
  </main-large-dialog>
</template>

<script>
import NmtSidebarProfileChart from '@/components/NmtSidebarProfileChart';
import NmtSidebarProfileChartDialogChip from '@/components/NmtSidebarProfileChartDialogChip';
import MainLargeDialog from '@/components/MainLargeDialog';

export default {
  name: 'NmtSidebarProfileChartDialog',
  components: {
    MainLargeDialog,
    NmtSidebarProfileChart,
    NmtSidebarProfileChartDialogChip,
  },
  props: {
    statistics: {
      type: Array,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
    heights: {
      type: Array,
      required: true,
    },
    length: {
      type: String,
      required: true,
    },
    interval: {
      type: Number,
      required: true,
      default: 1,
    },
    fresnelZonePoints: {
      type: Array,
    },
    titlePath: {
      type: String,
      default: 'dialog.title.nmtProfile',
    },
  },
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
  },
  methods: {
    downloadChart() {
      this.$refs.chart.downloadChart(this.$i18n.t(this.titlePath));
    },
  },
};
</script>

<style lang="scss" scoped></style>
